import { Component, DestroyRef, inject, OnInit, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthorizeService } from 'src/app/auth/authorize.service';
import { OrderClaimFilter } from 'src/app/common/OrderClaimFilter';
import { OrderService } from 'src/app/services/order.service';
import { FormsModule } from '@angular/forms';
import { DateRangeFilterComponent } from '../date-range-filter/date-range-filter.component';
import { FilterCardComponent } from '../filter-card/filter-card.component';
import { isDefaultFilter } from 'src/app/common/filter-state';

@Component({
    imports: [FormsModule, DateRangeFilterComponent, FilterCardComponent],
    selector: 'app-order-claim-search',
    templateUrl: './order-claim-search.component.html'
})
export class OrderClaimSearchComponent implements OnInit {
  private authService = inject(AuthorizeService);
  private orderService = inject(OrderService);

  private destroyRef = inject(DestroyRef);

  public filter: OrderClaimFilter = new OrderClaimFilter();
  tenantMode: boolean = false;

  readonly searchCriteria = output<OrderClaimFilter>();

  /** What the page opened with — the yardstick for the reset button (#228). */
  private defaults: OrderClaimFilter = new OrderClaimFilter();

  public get isFiltered(): boolean {
    return !isDefaultFilter({ ...this.filter }, { ...this.defaults });
  }

  public resetFilter(): void {
    this.filter = new OrderClaimFilter(
      this.defaults.retailerMode,
      this.defaults.dateFrom,
      this.defaults.dateTo,
      this.defaults.cancellationPending,
      this.defaults.cancelled
    );
    this.refresh();
  }

  ngOnInit(): void {
    this.filter = this.orderService.getDefaultOrderClaimFilter();
    this.defaults = { ...this.filter };

    this.authService.$retailerMode.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((tenantMode) => {
      this.tenantMode = tenantMode;
      this.refresh();
    });
  }

  public oncancellationPendingChanged(_e: Event){
    this.refresh();
  }

  public onCancelledChanged(_e: Event){
    this.refresh();
  }

  protected refresh(){
    this.searchCriteria.emit(this.filter);
  }
}
